var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 45,
    height: 45.13,
    rx: 22.5,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0828 24.25L28.7494 19.9066H24.5817V17.088C24.5817 15.8997 25.1639 14.7414 27.0305 14.7414H28.9252V11.0434C28.9252 11.0434 27.2063 10.75 25.5657 10.75C22.1335 10.75 19.8891 12.8303 19.8891 16.5953V19.9056H16.073V24.25H19.8882V34.75H24.585V24.25H28.0828Z",
    fill: "#212833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFb);
export default __webpack_public_path__ + "static/media/contact-fb.c214f72ef09d1f9333a0c499718256b6.svg";
export { ForwardRef as ReactComponent };